// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-stepper.v-sheet {
  overflow: hidden;
}
:where(.vuetify-styles) .v-stepper.v-sheet {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-stepper.v-sheet {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-stepper.v-sheet.v-stepper--flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}

:where(.vuetify-styles) .v-stepper-header {
  align-items: center;
  display: flex;
  position: relative;
  overflow-x: auto;
  justify-content: space-between;
  z-index: 1;
}
:where(.vuetify-styles) .v-stepper-header {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-stepper-header .v-divider {
  margin: 0 -16px;
}
:where(.vuetify-styles) .v-stepper-header .v-divider:last-child {
  margin-inline-end: 0;
}
:where(.vuetify-styles) .v-stepper-header .v-divider:first-child {
  margin-inline-start: 0;
}
:where(.vuetify-styles) .v-stepper--alt-labels .v-stepper-header {
  height: auto;
}
:where(.vuetify-styles) .v-stepper--alt-labels .v-stepper-header .v-divider {
  align-self: flex-start;
  margin: 35px -67px 0;
}

:where(.vuetify-styles) .v-stepper-window {
  margin: 1.5rem;
}

:where(.vuetify-styles) .v-stepper-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}
:where(.vuetify-styles) .v-stepper .v-stepper-actions {
  padding: 0 1.5rem 1rem;
}
:where(.vuetify-styles) .v-stepper-window-item .v-stepper-actions {
  padding: 1.5rem 0 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VStepper/VStepper.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,uOAAuO;AACzO;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sOAAsO;AACxO;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE,uOAAuO;AACzO;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".v-stepper.v-sheet {\n  overflow: hidden;\n}\n.v-stepper.v-sheet {\n  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-stepper.v-sheet {\n  border-radius: 4px;\n}\n.v-stepper.v-sheet.v-stepper--flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n\n.v-stepper-header {\n  align-items: center;\n  display: flex;\n  position: relative;\n  overflow-x: auto;\n  justify-content: space-between;\n  z-index: 1;\n}\n.v-stepper-header {\n  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-stepper-header .v-divider {\n  margin: 0 -16px;\n}\n.v-stepper-header .v-divider:last-child {\n  margin-inline-end: 0;\n}\n.v-stepper-header .v-divider:first-child {\n  margin-inline-start: 0;\n}\n.v-stepper--alt-labels .v-stepper-header {\n  height: auto;\n}\n.v-stepper--alt-labels .v-stepper-header .v-divider {\n  align-self: flex-start;\n  margin: 35px -67px 0;\n}\n\n.v-stepper-window {\n  margin: 1.5rem;\n}\n\n.v-stepper-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n}\n.v-stepper .v-stepper-actions {\n  padding: 0 1.5rem 1rem;\n}\n.v-stepper-window-item .v-stepper-actions {\n  padding: 1.5rem 0 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
